import * as React from "react";
const SvgFiRrPeace = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-peace_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m10 12c0 1.864-.513 3.61-1.405 5.105L13 9.51V2.05c5.046.503 9 4.773 9 9.95M11 2.05v7.421l-7.61 7.61A9.93 9.93 0 0 1 2 12c0-5.177 3.954-9.447 9-9.95M4.591 18.709 11 12.3v9.651a9.99 9.99 0 0 1-6.409-3.242M13 21.95v-9.612l6.391 6.391A9.98 9.98 0 0 1 13 21.95"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-peace_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPeace;
